import script from "./ReturnOpdBill.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnOpdBill.vue?vue&type=script&setup=true&lang=js"

import "./ReturnOpdBill.vue?vue&type=style&index=0&id=5690d2c3&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5690d2c3"]])

export default __exports__